import { useContext, useEffect } from "react";
import { CgCloseO } from "react-icons/cg";
import { ActionType, ModalsContext } from "../../Components/Contexts/ModalsContext";
import parse from "html-react-parser";
import "./Notification.css";

function Notification({
  text, // html string
  timeout, // in seconds
  height,
  width,
  type,
  onClose,
}) {
  const { state, dispatch } = useContext(ModalsContext);

  const addCSS = () => {
    if (type === "success") {
      document.getElementById("Notification").classList.add("notification-success");
    } else if (type === "error") {
      document.getElementById("Notification").classList.add("notification-error");
    }
  };

  useEffect(() => {
    const closeModalEvent = function (event) {
      if (!event.target.closest("#Notification")) {
        closeModal();
      }
    };

    function closeModal() {
      dispatch({ type: ActionType.setShowNotificationModal });
      if (onClose !== undefined) onClose();
    }
    document.addEventListener("click", closeModalEvent, true);

    if (width !== undefined && height !== undefined) {
      const notificationModalData = document.getElementById("Notification");
      notificationModalData.style.height = height;
      notificationModalData.style.width = width;
    }
    if (timeout !== undefined) {
      setTimeout(() => {
        document.getElementById("Notification").classList.add("fadeOut");
        setTimeout(() => {
          closeModal();
        }, 280); // A little less then the time of the fade out animation for smooth transition
      }, timeout * 1000);
    }
    if (type !== undefined) {
      addCSS();
    }
    return () => document.removeEventListener("click", closeModalEvent, true);
  }, []);

  return (
    <div className="modal-no-background notification-modal">
      <div id="Notification" className="small-modal">
        <div
          className="modal-title"
          style={{ backgroundColor: "inherit", alignItems: "flex-end", justifyContent: "flex-end" }}
        >
          <button
            className="close-modal-btn"
            style={{ color: "black" }}
            onClick={() => {
              dispatch({
                type: ActionType.setShowNotificationModal,
              });
              if (onClose !== undefined) onClose();
            }}
          >
            <CgCloseO size={25} />
          </button>
        </div>
        <div className="modal-data notification-modal-data">
          <div className="notification-modal-text">{parse(text !== undefined ? text : "")}</div>
        </div>
      </div>
    </div>
  );
}

export default Notification;
